// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner__ZBfdz","topchik":"topchik__1eF4w","bottom":"bottom__1Vtv3","slide":"slide__1gLiY"};